/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Enablement } from '../model';
// @ts-ignore
import { ScopedEnablements } from '../model';
/**
 * EnablementApi - axios parameter creator
 * @export
 */
export const EnablementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get enablements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnablements: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/shared/enablements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The caller\'s enablements with no scope context, plus one entry per scope the caller reaches. A scope the caller cannot reach has no entry.
         * @summary Get enablements, unioned and per scope
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopedEnablements: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/shared/scoped-enablements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnablementApi - functional programming interface
 * @export
 */
export const EnablementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnablementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get enablements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnablements(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Enablement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnablements(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The caller\'s enablements with no scope context, plus one entry per scope the caller reaches. A scope the caller cannot reach has no entry.
         * @summary Get enablements, unioned and per scope
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScopedEnablements(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScopedEnablements>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScopedEnablements(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnablementApi - factory interface
 * @export
 */
export const EnablementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnablementApiFp(configuration)
    return {
        /**
         * 
         * @summary Get enablements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnablements(options?: any): AxiosPromise<Array<Enablement>> {
            return localVarFp.getEnablements(options).then((request) => request(axios, basePath));
        },
        /**
         * The caller\'s enablements with no scope context, plus one entry per scope the caller reaches. A scope the caller cannot reach has no entry.
         * @summary Get enablements, unioned and per scope
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopedEnablements(options?: any): AxiosPromise<ScopedEnablements> {
            return localVarFp.getScopedEnablements(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnablementApi - object-oriented interface
 * @export
 * @class EnablementApi
 * @extends {BaseAPI}
 */
export class EnablementApi extends BaseAPI {
    /**
     * 
     * @summary Get enablements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnablementApi
     */
    public getEnablements(options?: any) {
        return EnablementApiFp(this.configuration).getEnablements(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The caller\'s enablements with no scope context, plus one entry per scope the caller reaches. A scope the caller cannot reach has no entry.
     * @summary Get enablements, unioned and per scope
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnablementApi
     */
    public getScopedEnablements(options?: any) {
        return EnablementApiFp(this.configuration).getScopedEnablements(options).then((request) => request(this.axios, this.basePath));
    }
}
